(function () {

  function initVideoHero(section) {

    if (!section) {
      return;
    }


    /* =====================================================
       PREVENT DUPLICATE INITIALIZATION
       ===================================================== */

    if (
      section.dataset.soundToggleInitialized === 'true'
    ) {
      return;
    }


    const video =
      section.querySelector('.ns-video-hero__video');

    const button =
      section.querySelector('.ns-video-hero__sound');

    const text =
      section.querySelector('.ns-video-hero__sound-text');


    if (!video || !button) {
      return;
    }


    section.dataset.soundToggleInitialized = 'true';


    /* =====================================================
       UPDATE SOUND BUTTON
       ===================================================== */

    function updateSoundButton() {

      if (video.muted) {

        button.classList.remove('is-unmuted');

        button.setAttribute(
          'aria-label',
          'Turn sound on'
        );

        button.setAttribute(
          'aria-pressed',
          'false'
        );

        if (text) {
          text.textContent = 'Sound On';
        }

      } else {

        button.classList.add('is-unmuted');

        button.setAttribute(
          'aria-label',
          'Turn sound off'
        );

        button.setAttribute(
          'aria-pressed',
          'true'
        );

        if (text) {
          text.textContent = 'Sound Off';
        }

      }

    }


    /* =====================================================
       INITIAL VIDEO STATE
       ===================================================== */

    video.muted = true;

    video.defaultMuted = true;

    updateSoundButton();


    /* =====================================================
       SOUND TOGGLE
       ===================================================== */

    button.addEventListener(
      'click',
      function (event) {

        event.preventDefault();

        event.stopPropagation();


        /*
         * Toggle the actual video mute state.
         *
         * MUTED     → UNMUTED
         * UNMUTED   → MUTED
         */

        video.muted = !video.muted;


        /*
         * When turning sound ON,
         * make sure volume is audible.
         */

        if (!video.muted) {

          video.volume = 1;


          const playPromise = video.play();


          if (
            playPromise &&
            typeof playPromise.catch === 'function'
          ) {

            playPromise.catch(
              function () {

                /*
                 * Browser refused unmuted playback.
                 * Return safely to muted state.
                 */

                video.muted = true;

                updateSoundButton();

              }
            );

          }

        }


        updateSoundButton();

      }
    );


    /* =====================================================
       KEEP BUTTON IN SYNC WITH VIDEO
       ===================================================== */

    video.addEventListener(
      'volumechange',
      function () {

        updateSoundButton();

      }
    );

  }


  /* =======================================================
     INITIALIZE EXISTING SECTIONS
     ======================================================= */

  function initializeAll() {

    document
      .querySelectorAll('.ns-video-hero')
      .forEach(
        function (section) {

          initVideoHero(section);

        }
      );

  }


  /* =======================================================
     NORMAL PAGE LOAD
     ======================================================= */

  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initializeAll
    );

  } else {

    initializeAll();

  }


  /* =======================================================
     SHOPIFY THEME EDITOR
     ======================================================= */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      const loadedSection = event.target;


      if (!loadedSection) {
        return;
      }


      if (
        loadedSection.classList &&
        loadedSection.classList.contains(
          'ns-video-hero'
        )
      ) {

        initVideoHero(
          loadedSection
        );

        return;
      }


      const hero =
        loadedSection.querySelector
          ? loadedSection.querySelector(
              '.ns-video-hero'
            )
          : null;


      if (hero) {

        initVideoHero(hero);

      }

    }
  );

})();